const MAP = {
  belum_bayar: ["Belum Dibayar", "bg-amber-500/15 text-amber-700"],
  menunggu: ["Menunggu Persetujuan", "bg-sky-500/15 text-sky-700"],
  lunas: ["Lunas", "bg-emerald-500/15 text-emerald-700"],
};

export const InvoiceStatus = ({ s, overdue, testId }) => {
  const [label, cls] = s !== "lunas" && overdue ? ["Lewat Jatuh Tempo", "bg-rose-500/15 text-rose-700"] : MAP[s];
  return <span className={`rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${cls}`} data-testid={testId}>{label}</span>;
};
